import { IWellKnownFolder } from "../interfaces/IWellKnownFolder";

export const WellKnownFolders: IWellKnownFolder[] = [
    {name: "archive", icon: "Archive"},
    {name: "clutter", icon: "FileBug"},
    {name: "conflicts", icon: "Important"},
    {name: "conversationhistory", icon: "Chat"},
    {name: "deleteditems", icon: "Delete"},
    {name: "drafts", icon: "Edit"},
    {name: "inbox", icon: "Inbox"},
    {name: "junkemail", icon: "Blocked2"},
    {name: "localfailures", icon: "ErrorBadge"},
    {name: "msgfolderroot", icon: "FolderHorizontal"},
    {name: "outbox", icon: "Edit"},
    {name: "recoverableitemsdeletions", icon: "RecycleBin"},
    {name: "scheduled", icon: "Clock"},
    {name: "searchfolders", icon: "FolderSearch"},
    {name: "sentitems", icon: "Send"},
    {name: "serverfailures", icon: "Server"},
    {name: "syncissues", icon: "FabricUnsyncFolder"}
];